import AppConfiguration from "dataProvider/config";
import BaseService from "./BaseService";
import { axiosBlobInstance } from "./SmartScaleService";

export default class DeviceService extends BaseService {
  constructor() {
    super(AppConfiguration.apiBaseMap, "device/v1");
  }

  // Camera AI
  /**
   * Lấy danh sách ảnh nhận diện khuân mặt của user
   * @param {*} params
   * @returns
   */
  getCameraAIUsers(params) {
    params.page = params.page > 0 ? params.page - 1 : 0;
    const path = "/ai-camera/user-management";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  /**
   * Lấy danh sách log theo username với log mới nhất
   * @param {*} params
   * @returns
    /**
   * Lấy danh sách log theo username với log mới nhất
   * @param {*} params 
   * @returns 
   */
  getCameraAILatestLogs(params) {
    params.page = params.page > 0 ? params.page - 1 : 0;
    const path = "/ai-camera/search-latest-log";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  /**
   * Lấy danh sách log chi tiết
   * @param {*} params
   * @returns
   * Lấy danh sách log chi tiết
   * @param {*} params
   * @returns
   */
  getCameraAILogs(params) {
    params.page = params?.page > 0 ? params?.page - 1 : 0;
    const path = "/ai-camera/logs";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  addCameraAIUser(data) {
    const path = "/ai-camera/user-management";
    return this.doPost(path, data);
  }

  editCameraAIUser(data) {
    const path = "/ai-camera/user-management";
    const configs = this.getConfigs({
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
    return this.doPut(path, data, configs);
  }

  deleteCameraAIUser(id) {
    const path = `/ai-camera/user-management/${id}`;
    const configs = this.getConfigs({});
    return this.doDelete(path, configs);
  }

  getCameraAIInfos(params) {
    params.page = params.page > 0 ? params.page - 1 : 0;
    const path = "/ai-camera/camera-infos";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  addCameraAIInfo(data) {
    const path = "/ai-camera/camera-infos";
    return this.doPost(path, data);
  }

  editCameraAIInfo(data) {
    const path = `/ai-camera/camera-infos/${data.mac}`;

    return this.doPut(path, data);
  }

  deleteCameraAIInfo(id) {
    const path = `/ai-camera/camera-infos/${id}`;
    const configs = this.getConfigs({});
    return this.doDelete(path, configs);
  }

  /**
   * Lấy danh sách filters
   * @returns
   */
  getCameraAIFilters() {
    const path = "/ai-camera/filters";
    const configs = this.getConfigs({});
    return this.doGet(path, configs);
  }

  /**
   * Lấy danh sách user theo search
   * @param {*} keySearch
   * @returns
   */
  getCameraAISuggestUsers(keySearch) {
    const path = "/ai-camera/user-management/suggest";
    const configs = this.getConfigs({
      params: {
        key_search: keySearch
      }
    });
    return this.doGet(path, configs);
  }

  /**
   * Lấy danh sách tủ locker vtv
   */
  async getOtpCabinet(params) {
    const path = "smart-lock/search-otp-cabinet";
    const configs = this.getConfigs({
      params
    });
    return await this.doGet(path, configs);
  }

  /**
   * Mở tủ
   */
  async clearOtpCabinet(params) {
    const path = "smart-lock/cell/clear-otp";
    const configs = this.getConfigs({
      params
    });
    return await this.doGet(path, configs);
  }
  /**
   * Xem thông tin cell của tủ
   */
  async openCodeCabinet(params) {
    const path = "smart-lock/cell/open-code";
    const configs = this.getConfigs({
      params
    });
    return await this.doGet(path, configs);
  }

  async getLogCabinetVtv(params) {
    const path = "smart-lock/log/cabinet-vtv";
    const configs = this.getConfigs({
      params
    });
    return await this.doGet(path, configs);
  }
  /**
   * Lấy danh sách ảnh duyệt đơn hàng
   */
  async getImagePackage(params) {
    const path = "image-packages";
    const configs = this.getConfigs({
      params
    });
    return await this.doGet(path, configs);
  }

  // Quản lý scanner
  getFlashScanner(params) {
    const path = "scanner";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  deleteFlashScanner(mac) {
    let path = `scanner/${mac}`;
    return this.doDelete(path);
  }

  addFlashScanner(data) {
    let path = `scanner`;
    return this.doPost(path, data);
  }

  editFlashScanner(data) {
    let path = `scanner/${data._id}`;
    delete data._id;
    return this.doPut(path, data);
  }

  getListType(params) {
    const path = "scanner/filters";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  // WheelSorter
  getWheelSorterLogs(params) {
    const path = "wheel/logs";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  downloadWheelSorterLogs(params) {
    const path = "wheel/logs/download";
    const configs = this.getConfigs({
      params,
      responseType: "blob"
    });
    return this.doGet(path, configs);
  }

  getPlcMaster(params) {
    const path = "wheel/plc/master";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  deletePlcMaster(code) {
    let path = `wheel/plc/master/${code}`;
    return this.doDelete(path);
  }

  addPlcMaster(data) {
    let path = `wheel/plc/master`;
    return this.doPost(path, data);
  }

  editPlcMaster(data) {
    let path = `wheel/plc/master`;
    return this.doPut(path, data);
  }

  getSelectData(params) {
    const path = "wheel/config/position";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getPlcSlave(params) {
    const path = "wheel/plc/slave";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  deletePlcSlave(code) {
    let path = `wheel/plc/slave/${code}`;
    return this.doDelete(path);
  }

  addPlcSlave(data) {
    let path = `wheel/plc/slave`;
    return this.doPost(path, data);
  }

  editPlcSlave(data) {
    let path = `wheel/plc/slave`;
    return this.doPut(path, data);
  }

  getPlcByType(params) {
    const path = "wheel/plc/filter";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getWheelScanner(params) {
    const path = "wheel-devices/scanner";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  deleteWheelScanner(id) {
    let path = `wheel-devices/scanner/${id}`;
    return this.doDelete(path);
  }

  addWheelScanner(data) {
    let path = `wheel-devices/scanner`;
    return this.doPost(path, data);
  }

  editWheelScanner(data, id) {
    let path = `wheel-devices/scanner/${id}`;
    return this.doPut(path, data);
  }

  getWheelScannerByType() {
    const path = "wheel/scanner/type";
    return this.doGet(path);
  }

  getWheelLine(params) {
    const path = "wheel/config/line/inbound";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  addPlcSlaveChute(data) {
    let path = `wheel/plc/slave/chute`;
    return this.doPost(path, data);
  }

  // Quản lý RFID
  getRFIDList(params) {
    const path = "rfid/controller";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  deleteRFID(mac) {
    let path = `rfid/controller/${mac}`;
    return this.doDelete(path);
  }

  addRFID(data) {
    let path = `rfid/controller`;
    return this.doPost(path, data);
  }

  editRFID(data) {
    let path = `rfid/controller`;
    return this.doPut(path, data);
  }

  getRFIDLogs(params) {
    const path = "rfid/log";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getRFIDStations() {
    const path = "rfid/config/station";
    return this.doGet(path);
  }

  getRFIDBagList(params) {
    const path = "rfid/config/bag";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  addRFIDBag(data) {
    let path = `rfid/config/bag`;
    return this.doPost(path, data);
  }

  getTemplateRFID() {
    // const path = "rfid/config/bag/template";
    // return this.doGet(path);

    let path = `/device/v1/rfid/config/bag/template`;
    return axiosBlobInstance.get(path);
  }

  importConfigRFID(data) {
    let path = `rfid/config/bags`;
    return this.doPost(path, data);
  }

  exportReportRFID(params) {
    let path = `/device/v1/rfid/date-report`;
    return axiosBlobInstance.get(path, { params });
  }

  getRFIDScannerLogs(params) {
    const path = "mobile/order-logs";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getZoneByStation(params) {
    const path = "mobile/station/gates";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  // Quản lý controller wheel
  getWheelController(params) {
    const path = "/wheel-devices/controller";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  deleteWheelController(id) {
    let path = `/wheel-devices/controller/${id}`;
    return this.doDelete(path);
  }

  getAllController() {
    const path = "/wheel-devices/controller/all";
    return this.doGet(path);
  }

  addWheelController(data) {
    let path = `wheel-devices/controller`;
    return this.doPost(path, data);
  }

  editWheelController(data, id) {
    let path = `wheel-devices/controller/${id}`;
    return this.doPut(path, data);
  }
  printerResetBlackList(data) {
    let path = `printer/surveys/reset-blacklist`;
    return this.doPost(path, data);
  }
  printerUpdateSetting(data) {
    let path = `device-setting/update-setting`;
    return this.doPost(path, data);
  }
  printerGetSetting(params) {
    let path = `device-setting`;
    return this.doGet(path, {
      params
    });
  }

  // Nhận diện khuôn mặt
  getFaceRecognitionList(params) {
    const path = "face-recognition/log/list";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  validateFaceRecognition(data) {
    let path = `face-recognition/validate`;
    return this.doPost(path, data);
  }
}
